import { Component, inject } from '@angular/core';
import {
  MatSnackBarAction,
  MatSnackBarActions,
  MatSnackBarLabel,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { ButtonComponent } from 'htx-ui-library';

@Component({
  selector: 'app-success-snackbar',
  templateUrl: 'success-snackbar.component.html',
  styleUrls: ['./success-snackbar.component.scss'],
  imports: [
    ButtonComponent,
    MatSnackBarLabel,
    MatSnackBarActions,
    MatSnackBarAction,
  ],
})
export class SuccessSnackbarComponent {
  snackBarRef = inject(MatSnackBarRef);
}
